import validation from "@/mixins/validation";
import { email, maxLength, required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
    name: "CosmoBaseForm",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {
            payload: {
                name: "",
                last_name: "",
                phone: "",
            },
            validationErrors: {},
            loading: false,
        }
    },
    mixins: [validation],
    validations: {
        payload: {
            name: { required, maxLength: maxLength(191) },
            last_name: { required, maxLength: maxLength(191) },
            phone: { required, maxLength: maxLength(191) },
        }
    },
    created() {
      if(this.isAuthenticated) {
        this.payload.name = this.user.name;
        this.payload.last_name = this.user.lastName;
        this.payload.phone = this.user.phone;
      }
    },
    mounted() {},
    watch: {},
    computed: {
        ...mapGetters({
          isAuthenticated: `auth/isAuthenticated`,
          user: "profile/user",
        }),
        nameErrors() {
            return this.computeErrors("payload", "name", {
              required: "validationRequired",
              maxLength: { message: "validationMax", count: 191 },
            });
        },
        lastNameErrors() {
            return this.computeErrors("payload", "last_name", {
                required: "validationRequired",
                maxLength: { message: "validationMax", count: 191 },
            });
        },
        phoneErrors() {
            return this.computeErrors("payload", "phone", {
                required: "validationRequired",
                maxLength: { message: "validationMax", count: 191 },
            });
        },
    },
    methods: {
        async sendForm() {
            this.$v.payload.$touch();
            if (this.$v.payload.$invalid) {
                return;
            }
            this.loading = true;
            try {
                await this.$store.dispatch("cosmobase/SEND_COSMOBASE_FORM", this.payload);
                this.$toasted.success("Дані успішно надіслані");
                this.payload = {
                    name: "",
                    last_name: "",
                    phone: "",
                }
                this.$v.payload.$reset();
            } catch (error) {
                this.$toasted.error("Щось пішло не так, спробуйте ще раз");
                this.validationErrors = error.data.errors
            } finally {
                this.loading = false;
            }
        }
    }
}
